/**
 * Registry keys for local filter modules.
 * Used by LocalFiltersRegistry and individual filter providers.
 */
export const LOCAL_FILTERS_KEY_CHANNEL_FOCUS = 'channelFocus';
export const LOCAL_FILTERS_KEY_CHANNEL_FOCUS_SECONDARY = 'channelFocusSecondarySegment';
export const LOCAL_FILTERS_KEY_GLOBAL_BENCHMARKING = 'globalBenchmarking';
export const LOCAL_FILTERS_KEY_AGGREGATED_CONSENT = 'aggregatedConsent';
export const LOCAL_FILTERS_KEY_PARTNER_SCORE = 'partnerScore';
export const LOCAL_FILTERS_KEY_COMPETITOR_ANALYSIS = 'competitorAnalysis';
export const LOCAL_FILTERS_KEY_INSIGHTS = 'insights';
export const LOCAL_FILTERS_KEY_NETWORK_CONNECTION = 'networkConnection';

/**
 * Maps local filter registry keys to their sessionStorage keys.
 * Uses literal strings matching SessionStorageKey enum values to
 * avoid const enum + isolatedModules issues.
 */
export const LOCAL_FILTERS_STORAGE_MAP: Record<string, string> = {
  [LOCAL_FILTERS_KEY_CHANNEL_FOCUS]: 'CHANNEL_FOCUS_FILTERS',
  [LOCAL_FILTERS_KEY_CHANNEL_FOCUS_SECONDARY]: 'CHANNEL_FOCUS_SECONDARY_SEGMENT_FILTERS',
  [LOCAL_FILTERS_KEY_GLOBAL_BENCHMARKING]: 'GLOBAL_BENCHMARKING_FILTERS',
  [LOCAL_FILTERS_KEY_AGGREGATED_CONSENT]: 'AGGREGATED_CONSENT_FILTERS',
  [LOCAL_FILTERS_KEY_PARTNER_SCORE]: 'PARTNER_SCORE_FILTERS',
  [LOCAL_FILTERS_KEY_COMPETITOR_ANALYSIS]: 'COMPETITOR_ANALYSIS_FILTERS',
  [LOCAL_FILTERS_KEY_INSIGHTS]: 'INSIGHTS_FILTERS',
};
